<template>
  <div>
    <div :class="['Form-field Form-field--checkbox', className ]">
      <input
        :id="id"
        :name="name"
        :value="modelValue"
        :required="required"
        :checked="isChecked"
        :disabled="disabled"
        v-bind="$attrs"
        type="checkbox"
        class="Form-input"
        @change="onChange"
      >
      <label
        :for="id"
        class="Form-label"
      >
        {{ label }}
        <span v-if="required">*</span>
      </label>
    </div>
    <error-messages
      :errors="error.errors"
    />
    <hint-message
      :hint="hint"
    />
  </div>
</template>

<script>
import formInputMixin from '@/mixins/form-input-mixin';

export default {
  name: 'RmpCheckbox',

  mixins: [formInputMixin],

  props: {
    id: {
      type: String,
      default() {
        return `checkbox-id-${Math.floor(Math.random() * 1000) * 5}`;
      },
    },
    name: {
      type: String,
      default: null,
    },
    modelValue: {
      default: null,
      type: [String, Number, Boolean, Array],
    },
    value: {
      default: null,
      type: [String, Number, Boolean],
    },
    className: {
      type: String,
      default: null,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      required: true,
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: 'Boolean',
    },
  },

  emits: ['update:modelValue', 'rmp:change'],

  computed: {
    isChecked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value);
      }

      return this.modelValue == this.value; //eslint-disable-line
    },
  },
  methods: {
    removeItemFromModel(newModel) {
      const index = newModel.indexOf(this.value);

      if (index !== -1) {
        newModel.splice(index, 1);
      }
    },
    onChange() {
      if (this.disabled) {
        return;
      }

      if (this.mode === 'Boolean') {
        this.$emit('update:modelValue', !this.modelValue);
        this.$emit('rmp:change', !this.modelValue);
      } else if (this.modelValue === this.value) {
        this.$emit('update:modelValue', null);
        this.$emit('rmp:change', null);
      } else {
        const newModel = this.modelValue === null ? [] : this.modelValue;

        if (!this.isChecked) {
          newModel.push(this.value);
        } else {
          this.removeItemFromModel(newModel);
        }
        this.$emit('update:modelValue', newModel);
        this.$emit('rmp:change', newModel);
      }
    },
  },
};
</script>
